import {UserAccess, UserAccessRequest} from './types';
import {FetchResult, nFetch} from '../../../api/nFetch';

export abstract class UserManagementCrud {
    abstract list(org_uid: string): Promise<FetchResult<UserAccess[]>>;

    abstract invite_user(org_uid: string, user: UserAccess): Promise<FetchResult<UserAccess>>;

    abstract remove_user(org_uid: string, user: UserAccess): Promise<FetchResult<{}>>;

    abstract my_invites(): Promise<FetchResult<UserAccess[]>>;

    abstract respond_invite(org_uid: string, response: string): Promise<FetchResult<{}>>;
}

class CrudImpl extends UserManagementCrud {
    async list(org_uid: string) {
        return nFetch<UserAccess[]>(`/organization/${org_uid}/users`);
    }

    async invite_user(org_uid: string, user: UserAccessRequest) {
        return nFetch<UserAccess>(`/organization/${org_uid}/users`, {
            method: 'POST',
            body: JSON.stringify(user),
        });
    }

    async remove_user(org_uid: string, user: UserAccess) {
        return nFetch<{}>(
            `/organization/${org_uid}/users`,
            {
                method: 'DELETE',
                body: JSON.stringify({
                    username: user.username,
                    email: user.email,
                }),
            },
            false,
        );
    }

    async my_invites() {
        return nFetch<UserAccess[]>('/organization/invites');
    }

    async respond_invite(org_uid: string, response: string) {
        return nFetch<{}>(`/organization/invites`, {
            method: 'POST',
            body: JSON.stringify({
                organization_uid: org_uid,
                response,
            }),
        });
    }
}

export default new CrudImpl();
